import { call, put, takeLatest } from 'redux-saga/effects';

import { getIncomeInformations } from '../../services/API';
import {
  actionTypes,
  requestFailure,
  requestSuccess,
} from 'modules/UserIncomes/redux/incomeInformations/actions';

function* getData(action) {
  const response = yield call(getIncomeInformations, action.payload);
  yield put(response.isOk ? requestSuccess(response.data) : requestFailure(response.error));
}

export default function* taxesSaga() {
  yield takeLatest(actionTypes.REQUEST_START, getData);
  yield takeLatest(actionTypes.REQUEST_START_SKIP_LOADING, getData);
}
